import { z } from "zod"

export const MailtrapWebhookEventSchema = z.object({
  timestamp: z.number(),
  event_id: z.string(),
  event: z.string(),
  category: z.string(),
  email: z.string(),
  message_id: z.string(),
  sending_domain_name: z.string(),
  sending_stream: z.string(),
})

export const MailtrapWebhookSchema = z.object({
  events: z.array(MailtrapWebhookEventSchema),
})
